/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

declare const require: any;

(function() {
  let lastTime = 0;
  const vendors = ['webkit', 'moz'];
  for(let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
      window.cancelAnimationFrame =
        window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function(callback) {
          const currTime = new Date().getTime();
          const timeToCall = Math.max(0, 16 - (currTime - lastTime));
          const id = window.setTimeout(function() { callback(currTime + timeToCall); },
            timeToCall);
          lastTime = currTime + timeToCall;
          return id;
      };

  if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function(id) {
          clearTimeout(id);
      };
}());

if (!("path" in Event.prototype))
Object.defineProperty(Event.prototype, "path", {
  get: function() {
    const path = [];
    let currentElem = this.target;
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
      path.push(document);
    if (path.indexOf(window) === -1)
      path.push(window);
    return path;
  }
});

 /***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es6/array';
import 'core-js/es6/date';
import 'core-js/es6/function';
import 'core-js/es6/map';
import 'core-js/es6/math';
import 'core-js/es6/number';
import 'core-js/es6/object';
import 'core-js/es6/parse-float';
import 'core-js/es6/parse-int';
import 'core-js/es6/regexp';
import 'core-js/es6/set';
import 'core-js/es6/string';
import 'core-js/es6/symbol';
import 'core-js/es6/weak-map';
import 'core-js/es7/array';
import 'core-js/es7/object';
import 'core-js/es6/promise';
/** IE10 and IE11 requires the following for NgClass support on SVG elements */
import 'classlist.js';  // Run `npm install --save classlist.js`.
/** IE10 and IE11 requires the following for the Reflect API. */
// import 'core-js/es6/reflect';
/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'core-js/es7/reflect';
import 'element-closest';
import 'scrolling-element';
import 'url-polyfill';
import 'performance-polyfill';
/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 **/
import 'web-animations-js'; // Run `npm install --save web-animations-js`.
/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js/dist/zone'; // Included with Angular CLI.
/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

const global = window;
// disable on properties
const targets = [window, Document, HTMLBodyElement, HTMLElement];
const __Zone_ignore_on_properties = [];
targets.forEach(target  => {
  __Zone_ignore_on_properties.push({
    target: target,
    ignoreProperties: ['scroll', 'wheel', 'mousemove']
  });
});

global['__zone_symbol__BLACK_LISTED_EVENTS'] = ['scroll', 'wheel', 'mousemove'];
global['__Zone_disable_requestAnimationFrame'] = true;
global['__Zone_disable_PromiseRejectionEvent'] = true;

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// Для страрперов типа гсапа, идиоты блять
try {
  if (window && !window['global']) {
    window['global'] = window;
  }
} catch (e) {}

// Ребята которые делаю cli, чет не учли опять pixijs не стартует
(window as any).process = {
  env: { DEBUG: undefined },
};


// // Полифил для Chrome < 43 (не поддерживает CSS свойство animate)
if (document.body.style['animation'] === undefined) {
  CSSStyleDeclaration.prototype['animation'] = '';
  CSSStyleDeclaration.prototype['animation-name'] = '';
  CSSStyleDeclaration.prototype['animation-duration'] = '';
  CSSStyleDeclaration.prototype['animation-timing-function'] = '';
  CSSStyleDeclaration.prototype['animation-delay'] = '';
  CSSStyleDeclaration.prototype['animation-iteration-count'] = '';
  CSSStyleDeclaration.prototype['animation-direction'] = '';
  CSSStyleDeclaration.prototype['animation-fill-mode'] = '';
  CSSStyleDeclaration.prototype['animation-play-state'] = '';
  CSSStyleDeclaration.prototype['animation'] = '';
  CSSStyleDeclaration.prototype['animationName'] = '';
  CSSStyleDeclaration.prototype['animationDuration'] = '';
  CSSStyleDeclaration.prototype['animationTimingFunction'] = '';
  CSSStyleDeclaration.prototype['animationDelay'] = '';
  CSSStyleDeclaration.prototype['animationIterationCount'] = '';
  CSSStyleDeclaration.prototype['animationDirection'] = '';
  CSSStyleDeclaration.prototype['animationFillMode'] = '';
  CSSStyleDeclaration.prototype['animationPlayState'] = '';
}


function normalizeUrl(url) {
  if (/^(http|https)/.test(url)) {
    return url;
  }

  return `${location.protocol}//${location.host}/${url}`;
}

(function() {
  const _Worker = window['Worker'];
  window['Worker'] = function (url, opts) {
    url = normalizeUrl(url);
    const blob = new Blob(["importScripts(" + JSON.stringify(url) + ")"], {
      type: "text/javascript"
    });
    return new _Worker(URL.createObjectURL(blob), opts);
  } as unknown as any;
})();

// @Ionic/core polyfill
if (window['NodeList'] && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach as any;
}
